import React, { useContext } from 'react';
import { Button, NewUserForm, Input } from 'components';
import { ListContext } from 'contexts/ListContext';
import { useModal } from 'hooks/useModal';
import { useTranslation } from 'react-i18next';
import { getStoredFilters } from '@utils/filters';
import { USER_KEY } from '@utils/constants';

export const UsersHeader = () => {
	const { t } = useTranslation();
	const { visible, toggleModal } = useModal();
	const { fetchUsers, setFilter } = useContext<any>(ListContext);
	const storedValue = getStoredFilters(USER_KEY);
	const handleOnNewUserClick = () => {
		toggleModal();
	};

	return (
		<>
			<div className='flex flex-row w-full mb-6 justify-between items-center'>
				<p className='text-lg'>Listado de Usuarios</p>
				<div className='flex flex-row items-center'>
					<Input
						className='flex items-center'
						placeholder={t('searchByNameEmailOrInstitution')}
						inputClasses='h-[44px] w-[500px]'
						icon='Search'
						defaultValue={storedValue?.text}
						onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
							setFilter({ text: e?.target?.value });
						}}
					/>
					<Button
						background
						textColor='white'
						className='w-52 ml-5 !py-2 !px-3'
						handleClick={handleOnNewUserClick}
					>
						+ Nuevo Usuario
					</Button>
				</div>
			</div>
			<NewUserForm
				visible={visible}
				toggle={toggleModal}
				fetchUsers={fetchUsers}
			/>
		</>
	);
};
